import {
  SET_USER,
  SET_AUTHENTICATED,
  SET_UNAUTHENTICATED,
  UPDATE_PROFILE,
} from "../types";
import { ActionType, InitialStateUserType } from '../../typings/state'

const initialState: InitialStateUserType = {
  authenticated: false,
  token: '',
  profile: undefined
};

const userReducer = function (state = initialState, action: ActionType) {
  switch (action.type) {
    case SET_AUTHENTICATED:
      return {
        ...state,
        authenticated: true,
      };
    case SET_UNAUTHENTICATED:
      return initialState;
    case SET_USER:
      return {
        authenticated: true,
        ...action.payload,
      };
    case UPDATE_PROFILE:
      return {
        ...state,
        profile: action.payload,
      };
    default:
      return state;
  }
}

export default userReducer;
